// extracted by mini-css-extract-plugin
export var container = "_70-0";
export var error = "_70-9";
export var label = "_70-5";
export var light = "_70-6";
export var md = "_70-3";
export var sm = "_70-2";
export var thin = "_70-8";
export var thinBold = "_70-7";
export var vertical = "_70-4";
export var xs = "_70-1";